import * as types from './constants';

const initialState = {
  data: null,
  loading: false,
  errors_api: {}
};

const actions = {
  // Get Shopify Token
  [types.GET_SHOPIFY_TOKEN_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_TOKEN_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_TOKEN_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_TOKEN_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

